var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import JsonExportButton from '~/js/components/atomos/JsonExportButton.vue';
import { dateFormat, dateView } from '~/js/modules/DateOperation';
var RankingLikes = /** @class */ (function (_super) {
    __extends(RankingLikes, _super);
    function RankingLikes() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.start = '2021-01-01';
        _this.today = '2021-12-31';
        _this.comments = [];
        _this.commentsJson = [];
        return _this;
    }
    Object.defineProperty(RankingLikes.prototype, "json", {
        get: function () {
            if (this.commentsJson.length < 2)
                return null;
            return {
                popular: this.commentsJson
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RankingLikes.prototype, "startDate", {
        get: function () {
            return dateFormat(this.start, 'yyyy年MM月');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RankingLikes.prototype, "endDate", {
        get: function () {
            return dateFormat(this.today, 'yyyy年MM月');
        },
        enumerable: false,
        configurable: true
    });
    RankingLikes.prototype.created = function () {
        var _this = this;
        gapi.client.load('youtubeAnalytics', 'v2', function () {
            var options = {
                ids: 'channel==MINE',
                startDate: _this.start,
                endDate: _this.today,
                maxResults: 5,
                dimensions: 'video',
                metrics: 'likes,views',
                sort: '-views'
            };
            var reports = gapi.client.youtubeAnalytics.reports.query(options);
            reports.execute(function (response) {
                console.log('==== Ranking (likes) ====');
                console.log(response);
                console.log('==== /Ranking (likes) ====');
                _this.commentsJson.push({
                    request: 'gapi.client.youtubeAnalytics.reports.query',
                    options: options,
                    result: response.result
                });
                _this._movieData(response.rows);
            });
        });
    };
    RankingLikes.prototype._movieData = function (data) {
        var _this = this;
        var ids = [];
        data.forEach(function (item) {
            ids.push(item[0]);
        });
        gapi.client.load('youtube', 'v3', function () {
            var options = {
                part: 'snippet,recordingDetails',
                maxResult: 5,
                id: ids.join(',')
            };
            var request = gapi.client.youtube.videos.list(options);
            request.execute(function (response) {
                console.log('==== Ranking (likes) - Videos ====');
                console.log(response);
                console.log('==== /Ranking (likes) - Videos ====');
                var res = response.items;
                _this._exec(data, res);
                _this.commentsJson.push({
                    request: 'gapi.client.youtube.videos.list',
                    options: options,
                    result: response.result
                });
            });
        });
    };
    RankingLikes.prototype._exec = function (data, movies) {
        var _this = this;
        data.forEach(function (d) {
            var movie = movies.find(function (movie) { return movie.id === d[0]; });
            _this.comments.push({
                id: d[0],
                title: movie.snippet.title,
                publishedAt: dateView(movie.snippet.publishedAt),
                thumbnail: movie.snippet.thumbnails.default.url,
                likes: d[1]
            });
        });
    };
    RankingLikes = __decorate([
        Component({
            components: { JsonExportButton: JsonExportButton }
        })
    ], RankingLikes);
    return RankingLikes;
}(Vue));
export default RankingLikes;
